import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
export const IconUserArrowPersonLeft = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("g", { style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" },
            React.createElement("path", { d: "M9.75042 12.75V11.9167C9.75653 11.5867 9.69603 11.2589 9.57256 10.9528C9.44908 10.6467 9.26516 10.3687 9.03179 10.1353C8.79841 9.90193 8.52038 9.71801 8.21431 9.59453C7.90823 9.47106 7.58041 9.41057 7.25042 9.41667H4.75042C4.42044 9.41057 4.09261 9.47106 3.78653 9.59453C3.48046 9.71801 3.20243 9.90193 2.96905 10.1353C2.73568 10.3687 2.55176 10.6467 2.42828 10.9528C2.30481 11.2589 2.24431 11.5867 2.25042 11.9167V12.75" }),
            React.createElement("path", { d: "M6.00042 6.91667C7.15101 6.91667 8.08375 5.98393 8.08375 4.83333C8.08375 3.68274 7.15101 2.75 6.00042 2.75C4.84982 2.75 3.91708 3.68274 3.91708 4.83333C3.91708 5.98393 4.84982 6.91667 6.00042 6.91667Z" }))));
};
export const IconUserArrowPersonRight = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("g", { style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" },
            React.createElement("path", { d: "M17.7504 12.75V11.9167C17.7565 11.5867 17.696 11.2589 17.5726 10.9528C17.4491 10.6467 17.2652 10.3687 17.0318 10.1353C16.7984 9.90193 16.5204 9.71801 16.2143 9.59453C15.9082 9.47106 15.5804 9.41057 15.2504 9.41667H12.7504C12.4204 9.41057 12.0926 9.47106 11.7865 9.59453C11.4805 9.71801 11.2024 9.90193 10.9691 10.1353C10.7357 10.3687 10.5518 10.6467 10.4283 10.9528C10.3048 11.2589 10.2443 11.5867 10.2504 11.9167V12.75" }),
            React.createElement("path", { d: "M13.9967 6.66667C14.9171 6.66667 15.6633 5.92048 15.6633 5C15.6633 4.07953 14.9171 3.33334 13.9967 3.33334C13.0762 3.33334 12.33 4.07953 12.33 5C12.33 5.92048 13.0762 6.66667 13.9967 6.66667Z" }))));
};
export const IconUserArrowArrow = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M15 16.7542V14.6233H12.84M5 14.6233C5.47392 15.4936 6.17369 16.2201 7.02565 16.7263C7.87762 17.2324 8.85027 17.4996 9.84125 17.4996C10.8322 17.4996 11.8049 17.2324 12.6568 16.7263C13.5088 16.2201 14.2086 15.4936 14.6825 14.6233", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" })));
};
const Wrapper = styled.div `
  --user-left-x: 0%;
  --user-left-y: 0%;
  --user-right-x: 0%;
  --user-right-y: 0%;
  --user-right-offset: 4px;
  --user-arrow-rotate: 0deg;

  position: relative;
`;
const Arrow = styled(IconUserArrowArrow) `
  transform: rotate(var(--user-arrow-rotate));
`;
const Left = styled(IconUserArrowPersonLeft) `
  position: absolute;
  left: 0;
  top: 0;
  transform-origin: 70% 40%;
  transform: translate(var(--user-left-x), var(--user-left-y));
`;
const Right = styled(IconUserArrowPersonRight) `
  position: absolute;
  left: 0;
  top: 0;
  transform-origin: 70% 40%;
  transform: translate(var(--user-right-x), var(--user-right-y));

  path {
    &:first-child {
      stroke-dasharray: 12px;
      stroke-dashoffset: var(--user-right-offset);
    }
  }
`;
export const IconUserArrow = (props) => {
    const wrapperRef = createRef();
    useEffect(() => {
        const wrapper = wrapperRef.current;
        if (!wrapper) {
            return;
        }
        gsap.from(wrapper, {
            keyframes: [
                {
                    '--user-arrow-rotate': '-20deg',
                    duration: 0.2,
                },
                {
                    '--user-arrow-rotate': '18deg',
                    duration: 0.325,
                },
                {
                    '--user-arrow-rotate': '0deg',
                    duration: 0.175,
                },
                {
                    '--user-arrow-rotate': '0deg',
                    duration: 0.1,
                },
            ],
            repeat: -1,
            repeatDelay: 1,
        });
        gsap.from(wrapper, {
            keyframes: [
                {
                    '--user-right-x': '12%',
                    '--user-right-y': '-5%',
                    '--user-right-offset': '2px',
                    duration: 0.2,
                },
                {
                    '--user-right-x': '0%',
                    '--user-right-y': '0%',
                    '--user-right-offset': '4px',
                    duration: 0.2,
                },
                {
                    '--user-left-x': '-12%',
                    '--user-left-y': '-5%',
                    duration: 0.15,
                },
                {
                    '--user-left-x': '0%',
                    '--user-left-y': '0%',
                    duration: 0.25,
                },
            ],
            repeat: -1,
            repeatDelay: 1,
        });
    }, []);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Left, null),
        React.createElement(Right, null),
        React.createElement(Arrow, null)));
};
//# sourceMappingURL=UserArrow.js.map